export const tsToDate = (timestamp) => {
    let date = timestamp.toDate()

    let mm = date.getMonth() + 1
    mm = mm < 10 ? `0${mm}` : mm
    let dd = date.getDate()
    dd = dd < 10 ? `0${dd}` : dd
    let yyyy = date.getFullYear()

    let hr = date.getHours()
    let min = date.getMinutes()
    // let sec = date.getSeconds()

    let newformat = hr >= 12 ? 'PM' : 'AM'
    hr = hr % 12
    hr = hr ? hr : 12

    return [
        `${dd}/${mm}/${yyyy}`,
        `${date.toString().split(' ')[0]}, ${date.toString().split(' ')[2]} ${
            date.toString().split(' ')[1]
        } ${date.toString().split(' ')[3]}`,
        `${hr < 10 ? `0${hr}` : hr} : ${
            min < 10 ? `0${min}` : min
        } ${newformat}`,
        date
    ]
}
